// import PackageDetailsList from './PackageDetailsList';
import PackageExplorer from './PackageExplorer';
// import PackageDetailShow from './PackageDetailShow';
import PackageDetailsIcon from '@material-ui/icons/CardTravel';

export default {
    list: PackageExplorer,
    icon: PackageDetailsIcon
};
